import { Component, OnInit, ViewChild } from "@angular/core";
import { Location, PopStateEvent } from "@angular/common";
import { Router, NavigationEnd, Event } from "@angular/router";
import { filter, Subscription } from "rxjs";
import { NavbarSuperAdminComponent } from "app/shared/navbar/navbar-superadmin/navbar-superadmin.component";
import { TabInfo, TABS_PEOPLE } from "../../interfaces/tab-routes.interface";
import { AuthService } from "app/core/services/auth.service";
import { environment } from "environments/environment";
import { InactivityService } from "app/core/services/helpers/inactivity.service";

@Component({
  selector: "admin-layout",
  templateUrl: "./admin-layout.component.html",
})
export class AdminLayoutComponent implements OnInit {
  private _router: Subscription;

  menuItems: TabInfo[];
  public history: string[] = [];

  url: string;
  location: Location;
  private lastPoppedUrl: string;
  private yScrollStack: number[] = [];
  @ViewChild("sidebar", { static: false }) sidebar;
  @ViewChild(NavbarSuperAdminComponent, { static: false })
  navbar: NavbarSuperAdminComponent;
  constructor(
    private router: Router,
    location: Location,
    private authService: AuthService,
    private inactivityService: InactivityService
  ) {
    this.location = location;
    this.router.events.subscribe((event: Event) => {
      let lastRoute;
      if (event instanceof NavigationEnd) {
        const segments = event.urlAfterRedirects.split("/");
        let segment = segments[segments.length - 1];
        // this.insertTabs(this.router.url);
        if (
          segment.startsWith("assigned-cameras-to-device") ||
          segment.startsWith("create-device") ||
          segment.startsWith("add-camera-to-device") ||
          segment.startsWith("show-camera") ||
          segment.startsWith("edit-camera") ||
          segment.startsWith("videorecord-recording") ||
          segment.startsWith("details-videofootage") ||
          segment.startsWith("addasset-to-incident") ||
          segment.startsWith("addvideofootage-to-incident")
        ) {
          lastRoute = this.history[this.history.length - 1];
        } else {
          if (this.router.url !== "/RefreshComponent") {
            this.history.push(this.router.url);
          }
          lastRoute = this.history[this.history.length - 2];
          if (typeof lastRoute == "undefined") {
            lastRoute = "/admin-panel/dashboard";
          } else {
            this.authService.saveLocalStorage(
              environment.storageLastRouteNameApi,
              lastRoute
            );
          }
        }
      }
    });
  }

  ngOnInit() {
    const elemMainPanel = <HTMLElement>document.querySelector(".main-panel");
    const elemSidebar = <HTMLElement>(
      document.querySelector(".sidebar .sidebar-wrapper")
    );
    this.location.subscribe((ev: PopStateEvent) => {
      this.lastPoppedUrl = ev.url;
    });
    const html = document.getElementsByTagName("html")[0];
    this._router = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (this.navbar) {
          this.navbar.sidebarClose();
        }
      });
  }

  insertTabs(currentUrl) {
    let showTabsPeople = currentUrl.startsWith(
      "/admin-panel/administration/people"
    );

    if (showTabsPeople) {
      this.menuItems = TABS_PEOPLE.filter((menuItem) => menuItem);
    } else {
      this.menuItems = [];
    }
  }
}
